import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  FilterReportsDto,
  ReportDto,
  ReportMetricsDto,
  ReportsListResponseDto,
} from '../molecules/reports/reports.types';

@Injectable({
  providedIn: 'root',
})
export class AdminReportsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  generate(startDate: string, endDate: string): Observable<ReportMetricsDto> {
    return this.http.post<ReportMetricsDto>(`${this.api}/reports/generate`, {
      startDate,
      endDate,
    });
  }

  save(startDate: string, endDate: string): Observable<ReportDto> {
    return this.http.post<ReportDto>(`${this.api}/reports`, {
      startDate,
      endDate,
    });
  }

  list(filter: FilterReportsDto = {}): Observable<ReportsListResponseDto> {
    return this.http.post<ReportsListResponseDto>(`${this.api}/reports/list`, filter);
  }
}
